import { listService } from "../../services/ListService";

import { mapGetters, mapMutations } from "vuex";

import Multiselect from "vue-multiselect";
import { Switch as cSwitch } from "@coreui/vue";

import EditAddress from "./../Common/editAddress.vue";

import { validationMixin } from "vuelidate";
import {
    required,
    requiredIf,
    numeric,
    minValue
} from "vuelidate/lib/validators";

export default {
    name: "EditProperty",

    components: {
        Multiselect,
        cSwitch,
        EditAddress
    },
    mixins: [validationMixin], //?
    data: () => {
        return {
            loading: true,

            property: {},

            // Copy address from owner
            copyAddress: false,
            //
            propertyType: null,
            propertyTypes: [], // Filled on created()
            //
            constructionType: null,
            constructionTypes: [], // Filled on created()
            //
            propertyBeam: null,
            propertyBeams: [], // Filled on created()
            //
            propertyCeiling: null,
            propertyCeilings: [], // Filled on created()
            //
            propertyWall: null,
            propertyWalls: [], // Filled on created()
            //
            propertyRoof: null,
            propertyRoofs: [], // Filled on created()
            //
            propertyRoofFraming: null,
            propertyRoofFramings: [], // Filled on created()
            //
            propertyRoofCover: null,
            propertyRoofCovers: [], // Filled on created()
            //
            buildYear: {},
            buildYears: [] // Filled on created()
        };
    },

    validations: {
        property: {
            Rooms: {
                required,
                numeric
            },
            Area: {
                required,
                numeric
            },
            Floors: {
                required,
                numeric
            },
            PropertiesWithSameAddress: {
                required,
                numeric,
                minValue: minValue(1)
            },
            Remarks: {
                required: requiredIf(function(model) {
                    return (
                        model.PropertiesWithSameAddress != undefined &&
                        model.PropertiesWithSameAddress != null &&
                        parseInt(model.PropertiesWithSameAddress) > 1
                    );
                })
            }
        },
        propertyType: {
            required
        },
        constructionType: {
            required
        },
        propertyBeam: {
            required
        },
        propertyCeiling: {
            required
        },
        propertyWall: {
            required
        },
        propertyRoof: {
            required
        },
        propertyRoofFraming: {
            required
        },
        propertyRoofCover: {
            required
        },
        buildYear: {
            required
        }
    },

    computed: {
        ...mapGetters({
            orderEditable: "order/orderEditable",
            orderProperty: "order/property",
            ownerAddress: "order/ownerAddress",
            propertyAddress: "order/propertyAddress"
        }),
        //
        isValid() {
            return !this.$v.$anyError;
        },
        propertyTypeIsInvalid() {
            return this.$v.propertyType.$anyError;
        },
        constructionTypeIsInvalid() {
            return this.$v.constructionType.$anyError;
        },
        propertyBeamIsInvalid() {
            return this.$v.propertyBeam.$anyError;
        },
        propertyCeilingIsInvalid() {
            return this.$v.propertyCeiling.$anyError;
        },
        propertyWallIsInvalid() {
            return this.$v.propertyWall.$anyError;
        },
        propertyRoofIsInvalid() {
            return this.$v.propertyRoof.$anyError;
        },
        propertyRoofFramingIsInvalid() {
            return this.$v.propertyRoofFraming.$anyError;
        },
        propertyRoofCoverIsInvalid() {
            return this.$v.propertyRoofCover.$anyError;
        },
        buildYearIsInvalid() {
            return this.$v.buildYear.$anyError;
        }
        //
    },

    // Fetches when the component is created.
    created() {
        this.loading = true;

        this.propertyTypes = listService.getPropertyTypes();
        this.constructionTypes = listService.getPropertyBuildTypes();
        this.propertyBeams = listService.getPropertyStructures();
        this.propertyCeilings = listService.getPropertyFloorSeparations();
        this.propertyWalls = listService.getPropertyWalls();
        this.propertyRoofs = listService.getPropertyRoofs();
        this.propertyRoofFramings = listService.getPropertyRoofStructures();
        this.propertyRoofCovers = listService.getPropertyRoofCovers();
        this.buildYears = listService.getPropertyBuildYears();

        this.property = JSON.parse(JSON.stringify(this.orderProperty));

        this.propertyType = this.propertyTypes.find(
            item => item.Code == this.property.Type
        );
        this.constructionType = this.constructionTypes.find(
            item => item.Code == this.property.ConstructionType
        );
        this.propertyBeam = this.propertyBeams.find(
            item => item.Code == this.property.Beam
        );
        this.propertyCeiling = this.propertyCeilings.find(
            item => item.Code == this.property.Ceiling
        );
        this.propertyWall = this.propertyWalls.find(
            item => item.Code == this.property.Walls
        );
        this.propertyRoof = this.propertyRoofs.find(
            item => item.Code == this.property.Roof
        );
        this.propertyRoofFraming = this.propertyRoofFramings.find(
            item => item.Code == this.property.RoofFraming
        );
        this.propertyRoofCover = this.propertyRoofCovers.find(
            item => item.Code == this.property.Covering
        );
        this.buildYear = this.buildYears.find(
            item => item.Code == this.property.ConstructionYear
        );

        this.loading = false;
    },

    methods: {
        ...mapMutations({
            setPropertyToOrder: "order/setProperty",
            setPropertyAddress: "order/setPropertyAddress"
        }),
        //
        validate: function() {
            this.$v.$touch();
            this.$nextTick(() => this.findFirstError());

            var addressIsValid = this.$refs.editPropAddress.validate();

            console.log("property addressIsValid" + addressIsValid);

            return this.isValid && addressIsValid;
        },
        chkState: function(val) {
            const field = this.getDescendantProp(this.$v, val);

            return !field.$dirty || !field.$invalid;
        },
        //
        propertyType_changed(value) {
            console.log("propertyType_changed");
            this.propertyType = value;
            this.property.Type = value.Code;
        },

        constructionType_changed(value) {
            console.log("constructionType_changed");
            this.constructionType = value;
            this.property.ConstructionType = value.Code;
        },

        propertyBeam_changed(value) {
            console.log("propertyBeam_changed");
            this.propertyBeam = value;
            this.property.Beam = value.Code;
        },

        propertyCeiling_changed(value) {
            console.log("propertyCeiling_changed");
            this.propertyCeiling = value;
            this.property.Ceiling = value.Code;
        },

        propertyWall_changed(value) {
            console.log("propertyWall_changed");
            this.propertyWall = value;
            this.property.Walls = value.Code;
        },

        propertyRoof_changed(value) {
            console.log("propertyRoof_changed");
            this.propertyRoof = value;
            this.property.Roof = value.Code;
        },

        propertyRoofFraming_changed(value) {
            console.log("propertyRoofFraming_changed");
            this.propertyRoofFraming = value;
            this.property.RoofFraming = value.Code;
        },

        propertyRoofCover_changed(value) {
            console.log("propertyRoofCover_changed");
            this.propertyRoofCover = value;
            this.property.Covering = value.Code;
        },

        buildYear_changed(value) {
            console.log("buildYear_changed");
            this.buildYear = value;
            this.property.ConstructionYear = value.Code;
        }
    },

    watch: {
        property: {
            handler: function(val, oldVal) {
                this.setPropertyToOrder(val);
            },
            deep: true
        },

        copyAddress: {
            handler: function(val, oldVal) {
                var address = JSON.parse(JSON.stringify(this.propertyAddress));
                if (val) {
                    address = {
                        Apartment: this.ownerAddress.Apartment,
                        Bloc: this.ownerAddress.Bloc,
                        County: this.ownerAddress.County,
                        Floor: this.ownerAddress.Floor,
                        No: this.ownerAddress.No,
                        Remarks: this.ownerAddress.Remarks,
                        Staircase: this.ownerAddress.Staircase,
                        Street: this.ownerAddress.Street,
                        Town: this.ownerAddress.Town,
                        SIRUTA: this.ownerAddress.SIRUTA,
                        ZipCode: this.ownerAddress.ZipCode
                    };
                } else {
                    address = {
                        Apartment: null,
                        Bloc: null,
                        County: null,
                        Floor: null,
                        No: null,
                        Remarks: null,
                        RowVersion: null,
                        Staircase: null,
                        Street: null,
                        Town: null,
                        SIRUTA: null,
                        ZipCode: null
                    };
                }
                this.setPropertyAddress(address);
                this.$refs.editPropAddress.loadAddress();
            }
        }
    }
};
